import React from 'react';
import { useSelector } from "react-redux";
import * as actionCreator from "../../../../action/index.js";
import CurrencyFormat from 'react-currency-format';

const TotalDiscount = () => {

  const state = useSelector((state) => ({
    ...state.reducer,
    ...state.orderExtrasReducer,
    ...state.priceUpdateReducer,
  }));

  let newCalculation = 0;
  if (state.const_var.post_data.building !== undefined) {
    if (
      state.order_extra_items['dont_show_processing_fee_pdf'] === "1" &&
      parseInt(state.const_var.order_extra_items['processing_fee']) !== 0
    ) {
      newCalculation =
        parseInt(state.const_var.post_data.building.down_payment_total -
          state.const_var.post_data.building.down_payment_discount_total) +
        parseInt(state.const_var.order_extra_items['processing_fee']);
    } else {
      newCalculation = (
        parseInt(state.const_var.post_data.building.down_payment_total -
          state.const_var.post_data.building.down_payment_discount_total)
      ).toFixed(2);
    }
  }

  let actualAmount = state.const_var.post_data.building !== undefined
    ? (
        state.const_var.post_data.building.sub_order_total +
        state.const_var.BuildingPriceArrar["custom_subTotal"]
      ).toFixed(2)
    : 0;

  if (
    state.const_var.offerApplied !== '' &&
    state.const_var.selectedDicountOfferobj &&
    state.const_var.selectedDicountOfferobj.applied_on === "base_price" &&
    state.const_var.post_data.building !== undefined &&
    state.const_var.post_data.building.discount_amount !== undefined
  ) {
    actualAmount = (
      actualAmount - (state.const_var.post_data.building.discount_amount || 0)
    ).toFixed(2);
  }

  return (
    <>
      <CurrencyFormat
        value={actualAmount}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
      />
    </>
  );
};

export default TotalDiscount;